import {
  useWSModalCustom,
  WSModal,
  WSModalCustomProps,
  WSTable,
  WSTableCell,
  WSTableColumn,
  WSTableItem,
  WSText
} from "@wingspanhq/fe-component-library";
import { formatMoney } from "@wingspanhq/utils/dist/formatMoney";
import { WorkLog } from "@wingspanhq/wingspan-api-sdk";
import React from "react";

import { selectorWorkLogLabel } from "../../WorkLogs/selectors/selectorWorkLogLabel";
import { PAYROLL_CURRENCY } from "../constants";
import { parsePayrollAmount } from "../utils";

const columns: WSTableColumn<WorkLog>[] = [
  {
    config: { header: { text: "Worklog" }, gridTemplateSizeMax: "1fr" },
    renderFunction: ({ data }) => (
      <WSTableCell text={selectorWorkLogLabel(data)} />
    )
  },
  {
    config: { header: { text: "Amount" }, justify: "end" },
    renderFunction: ({ data }) => (
      <WSTableCell
        text={formatMoney(
          parsePayrollAmount(data.totalAmount),
          PAYROLL_CURRENCY
        )}
      />
    )
  }
];

type Props = {
  workLogs: WorkLog[];
  onWorkLogOpen?: (id: string) => void;
} & WSModalCustomProps<void>;

const ModalReviewExcludedWorkLogs: React.FC<Props> = props => {
  const tableData: WSTableItem<WorkLog>[] = props.workLogs.map(workLog => ({
    id: workLog.id ?? "",
    data: workLog
  }));

  return (
    <WSModal
      actions={{
        alignment: "fill",
        buttons: [
          { label: "Done", kind: "Tertiary", onClick: () => props.onClose() }
        ]
      }}
      size="M"
      title="Not included work logs"
      onClose={() => props.onClose()}
    >
      <WSText.ParagraphSm color="gray500" mb="M">
        After a payroll run is finalized and paid, any work logs not included
        can only be paid in a separate off-cycle run.
      </WSText.ParagraphSm>
      <WSTable<WorkLog>
        columns={columns}
        tableData={tableData}
        onRowClick={item => props.onWorkLogOpen?.(item.id)}
      />
    </WSModal>
  );
};

export const useModalReviewExcludedWorkLogs = () =>
  useWSModalCustom(ModalReviewExcludedWorkLogs);
